// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"164":"1306a89c","213":"632ff227","311":"74654e4b","416":"aa6be0c4","643":"5e999d9a","791":"8a5f5162"}[chunkId] + ".chunk.js";
};